import { render, staticRenderFns } from "./AboutTakeover.vue?vue&type=template&id=0c1c3b6c&"
import script from "./AboutTakeover.vue?vue&type=script&lang=js&"
export * from "./AboutTakeover.vue?vue&type=script&lang=js&"
import style0 from "./AboutTakeover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/melissaallen/fuzzco/pretendstore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0c1c3b6c', component.options)
    } else {
      api.reload('0c1c3b6c', component.options)
    }
    module.hot.accept("./AboutTakeover.vue?vue&type=template&id=0c1c3b6c&", function () {
      api.rerender('0c1c3b6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/AboutTakeover.vue"
export default component.exports